import Vue from 'vue'
import App from './App'         // index.htmlのBody部（ベース）
import router from './router'   // 画面遷移
import cognito from './cognito' // AWS Cognito処理
import store from './store'     // ユーザープロフィール
import VueI18n from 'vue-i18n'; // 多言語対応
import axios from './axios.js'; // HTTPクライアント
import Utils from './common/utils.js' // 共通関数
import Viewer from 'v-viewer'   // イメージ画像プレビュー機能
import 'viewerjs/dist/viewer.css'

Vue.prototype.$axios = axios;
Vue.mixin(Utils);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'en', // 初期値：英語
  messages: {
    // 翻訳用のjsonを読込
    ja : require('./lang/ja.json'),
    en : require('./lang/en.json'),
  }
});

Vue.use(Viewer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  cognito,
  store,
  i18n: i18n,
  render: h => h(App),
}).$mount('#app')